import { observer } from 'mobx-react';
import React, { FC, useCallback, useEffect, useState } from 'react';

import { TARGET_EMOJI_ANIMATION_TIME } from '../../../constants';
import { TargetEmojiMessage } from '../../../model/chat/TargetEmojiMessage';
import chatStore from '../../../store/ChatStore';
import { PlayerTablePosition } from '../../Player/Player.types';
import AnimatedTargetEmoji from '../AnimatedTargetEmoji/AnimatedTargetEmoji';
import { AnimatedTargetEmojiDrawerProps } from './AnimatedTargetEmojiDrawer.types';

const AnimatedTargetEmojiDrawer: FC<AnimatedTargetEmojiDrawerProps> = ({
  tableId,
  playerPositions,
}) => {
  const [targetEmojiMessages, setTargetEmojiMessages] = useState<
    TargetEmojiMessage[]
  >([]);

  useEffect(() => {
    const targetMessages = [...chatStore.getTargetEmojiMessages(tableId)];
    setTargetEmojiMessages(targetMessages);
    if (targetMessages.length) {
      setTimeout(() => {
        chatStore.deleteTargetEmojiMessages(
          tableId,
          targetMessages.map(message => message.id),
        );
      }, TARGET_EMOJI_ANIMATION_TIME);
    }
  }, [chatStore.targetMessages.size, chatStore.targetEmojiStateChanged]);

  const getTargetEmojiPosition = useCallback(
    (pid: string): PlayerTablePosition => {
      if (playerPositions.length) {
        const playerPosition = playerPositions.find(
          p => p.player?.pid === pid,
        ).tablePosition;
        return {
          playerX: playerPosition.playerX + 70,
          playerY: playerPosition.playerY + 50,
        };
      }
    },
    [playerPositions, playerPositions.length],
  );

  return (
    <>
      {targetEmojiMessages.map(targetEmoji => (
        <AnimatedTargetEmoji
          key={targetEmoji.id}
          startPosition={getTargetEmojiPosition(targetEmoji.pid)}
          endPosition={getTargetEmojiPosition(targetEmoji.targetPid)}
          targetEmoji={targetEmoji}
        />
      ))}
    </>
  );
};

export default observer(AnimatedTargetEmojiDrawer);
